import React from 'react';
import { random, times } from 'lodash';
import { SkeletonImage } from '@bynder/design-system';
import { StyledPageContainer } from '../shared/styled-components/Page';
import {
  StyledSkeletonPageTitle,
  StyledSkeletonSeparator,
  StyledSkeletonWidget,
} from '../shared/styled-components/SkeletonContent';

const NUMBER_OF_WIDGETS = 15;

const MAX_WIDTH = 800;
const MIN_WIDTH = 350;

const SkeletonPage: React.FunctionComponent = () => {
  return (
    <StyledPageContainer style={{ marginTop: '72px' }}>
      <StyledSkeletonPageTitle />
      <StyledSkeletonSeparator />
      <div style={{ width: '100%', height: '400px', paddingTop: '15px' }}>
        <SkeletonImage />
      </div>
      {times(NUMBER_OF_WIDGETS, (index: number) => (
        <StyledSkeletonWidget
          key={index}
          width={random(MIN_WIDTH, MAX_WIDTH)}
        />
      ))}
    </StyledPageContainer>
  );
};

export default SkeletonPage;
